<template>
  <div class="border p-8 rounded shadow-2xl">
    <p class="text-STblue font-bold mb-2">Video preview</p>
    <div>
      <p
        class="
          font-AvenirBlackFont
          text-gray-600
          lg:text-xl
          md:text-md
          text-sm
          uppercase
        "
      >
        {{ form.title }}
      </p>
      <p class="font-AvenirFont text-gray-600 mb-3">{{ form.description }}</p>

      <VimeoVideo :link="form.link" :playVideo="true" />
    </div>
  </div>
</template>

<script>
import VimeoVideo from "../../VimeoVideo.vue";

export default {
  name: "VideoPreview",

  props: {
    form: Object,
  },

  components: {
    VimeoVideo,
  },
};
</script>
